import {Amplify} from 'aws-amplify';
import {generateClient} from 'aws-amplify/api';

const CHAT_APPSYNC_ENDPOINT = process.env.CHAT_APPSYNC_FE_URL ?? '';
const CHAT_APPSYNC_API_KEY = process.env.CHAT_APPSYNC_FE_API_KEY ?? '';

// Sole Amplify.configure in DMS; generateClient callers must pass authMode explicitly.
Amplify.configure({
  API: {
    GraphQL: {
      endpoint: CHAT_APPSYNC_ENDPOINT,
      defaultAuthMode: 'apiKey',
      apiKey: CHAT_APPSYNC_API_KEY,
    },
  },
});

const chatClient = generateClient({
  endpoint: CHAT_APPSYNC_ENDPOINT,
  authMode: 'apiKey',
  apiKey: CHAT_APPSYNC_API_KEY,
});

export const chatAppSync = chatClient;
